module.exports = __webpack_public_path__ + "static/img/hotel.704cd6f9.svg";